import * as L from "leaflet";
// @ts-ignore
import "leaflet-arrowheads";
import { LatLng } from "leaflet";

//Compute arrow head path points
export function ComputeArrowheadPoints(
  initlat: number,
  initlon: number,
  lat: number,
  lon: number
): number[][] {
  let size = 200;
  let arrowYawn = 40;
  let derivedLatLngs = new LatLng(lat, lon);
  let derivedBearings = angleFromCoordinate(initlat, initlon, lat, lon);

  // @ts-ignore
  let leftWingPoint = L.GeometryUtil.destination(
    derivedLatLngs,
    derivedBearings - arrowYawn / 2,
    size
  );

  // @ts-ignore
  let rightWingPoint = L.GeometryUtil.destination(
    derivedLatLngs,
    derivedBearings + arrowYawn / 2,
    size
  );

  // @ts-ignore
  let hatPoints = [
    [leftWingPoint.lat as number, leftWingPoint.lng as number],
    [derivedLatLngs.lat, derivedLatLngs.lng],
    [rightWingPoint.lat as number, rightWingPoint.lng as number],
  ];

  return hatPoints;
}

// Compute arrow head angle
function angleFromCoordinate(
  lat1: number,
  long1: number,
  lat2: number,
  long2: number
): number {
  lat1 = (lat1 * Math.PI) / 180;
  lat2 = (lat2 * Math.PI) / 180;
  long1 = (long1 * Math.PI) / 180;
  long2 = (long2 * Math.PI) / 180;

  let dLon = long2 - long1;

  let y = Math.sin(dLon) * Math.cos(lat2);
  let x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  let brng = Math.atan2(y, x);
  brng = (brng * 180) / Math.PI;
  brng = (brng + 360) % 360;
  brng = (brng + 180) % 360;

  return brng;
}
